import * as React from "react";
import styled from "styled-components";
import {
  ConstColor,
  ConstFontStyle,
} from "../../../../config/styles_const/styles_const";

interface IProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLHeadingElement>,
    HTMLHeadingElement
  > {}

const ErrorTextDefault: React.SFC<IProps> = (props) => {
  const { children, ...PProps } = props;

  return <p {...PProps}>{children}</p>;
};

const ErrorText = styled(ErrorTextDefault)`
  color: ${ConstColor.Error};
  font-style: normal;
  font-weight: ${ConstFontStyle.ErrorTextDefault.fontWeight};
  font-size: ${ConstFontStyle.ErrorTextDefault.fontSize};
  line-height: ${ConstFontStyle.ErrorTextDefault.lineHeight};
  ::before {
    margin-right: 5px;
    content: "\f06a";
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
  }
`;

export default ErrorText;



// WEBPACK FOOTER //
// ./src/presentation/common/atom/text/error_text.tsx